import { Link as MuiLink, Box, Button, Container, IconButton, Stack, Typography, useTheme } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2";
import { RoutePaths } from "../../routes";
import { Link } from "react-router-dom"
import { ReactComponent as GeroiYarIcon } from "../../icons/GeroiYar_f.svg"
import { ReactComponent as VkIcon } from "../../icons/VkIcon.svg"
import { ReactComponent as TelegramIcon } from "../../icons/TelegramIcon.svg"
import { Fragment } from "react";


const links = [
    [
        { label: 'Главная', url: RoutePaths.HOME },
        { label: 'Этапы', url: RoutePaths.STEPS },
        { label: 'Общественный совет', url: RoutePaths.OB_SOVET },
        { label: <Box><Button component={MuiLink} href={RoutePaths.LK} target="_blank" variant="contained" sx={{ backgroundColor: 'red.500' }}>Личный кабинет</Button></Box> },
    ],
    [
        { label: 'Порядок отбора', url: RoutePaths.RULES },
        { label: 'Поддержка участников', url: RoutePaths.SUPPORT },
        { label: 'Политика обработки персональных данных', url: RoutePaths.POLICY },
        { label: 'Контакты', url: RoutePaths.CONTACTS },
    ]
]


const Footer = () => {

    return (
        <>
            <Box sx={{
                backgroundColor: 'blue.400',
                color: 'white',
                width: '100%',
            }}>
                <Container maxWidth='lgp' sx={{
                    pt: 15,
                    pb: 15,
                }}>
                    <Grid container rowSpacing={5}>
                        <Grid sm={12} md={4}>
                            <Stack spacing={2}
                                alignItems={{
                                    md: 'flex-start',
                                    xs: 'center',
                                }}>
                                <GeroiYarIcon />
                                <Typography
                                    color="white"
                                    sx={{
                                        opacity: 0.6,
                                        fontSize: '11px',
                                        fontWeight: 400,
                                        letterSpacing: '0px',
                                        lineHeight: '13.2px',
                                        fontFamily: 'Fira Sans Condensed',
                                    }}
                                >Региональная программа развития для участников<br />
                                    специальной военной операции «Герои Ярославии»</Typography>
                                <Stack direction='row'>
                                    <IconButton component={MuiLink} href="https://vk.com/geroiyaroslavii" target="_blank" title="Герои Ярославии"><VkIcon style={{ fill: 'white' }} /></IconButton>
                                    <IconButton><TelegramIcon /></IconButton>
                                </Stack>
                            </Stack>
                        </Grid>

                        <Grid xs={12} sm={6} md={4}>
                            <ListLink label='ПРОГРАММА «ГЕРОИ ЯРОСЛАВИИ»' links={links[0]} />
                        </Grid>

                        <Grid xs={12} sm={6} md={4}>
                            <ListLink label='ДОПОЛНИТЕЛЬНО' links={links[1]} />
                        </Grid>
                    </Grid>

                    <Box sx = {{
                    width: '100%',
                    textAlign: 'center',
                    mt: 4,
                }}>
                    <Typography 
                    color="white"
                    sx = {{
                        opacity: 0.6,
                        fontSize: '11px',
                        fontWeight: 400,
                        letterSpacing: '0px',
                        lineHeight: '13.2px',
                        fontFamily: 'Fira Sans Condensed'
                    }}
                    >
                       Продолжая пользование настоящим сайтом, я выражаю своё согласие ГБУ ЯО «Электронный регион» на обработку моих персональных данных с использованием интернет-сервиса Яндекс.Метрика. Настоящее согласие вступает в силу с момента моего <br/> перехода на сайт «Герои Ярославии» и действует в течение сроков, установленных действующим законодательством Российской Федерации.
                    </Typography>

                </Box>
                </Container>
                
            </Box>
        </>
    )
}


const ListLink = ({ label, links }) => {
    const theme = useTheme()
    return (
        <>
            <Stack spacing={3}>
                <Typography color="white" fontSize='16px' variant='menu' sx={{
                    letterSpacing: 0,
                    fontWeight: 700,
                }}>{label}</Typography>
                {links.map(item => (
                    <Fragment key={item.label}>
                        {item.url
                            ? <MuiLink component={Link} key={item.label} to={item.url} underline="hover" sx={{
                                ...theme.typography.menu,
                                color: "white",
                                letterSpacing: 0,
                                fontWeight: 400,
                            }}
                                onClick={item.handleClick ? item.handleClick : () => null}
                            >{item.label}</MuiLink>
                            : item.label
                        }
                    </Fragment>
                ))}
            </Stack>
        </>
    )
}

export default Footer